import { TokenRefreshLink } from "apollo-link-token-refresh";
import moment from "moment";
import jwtDecode from "jwt-decode";
import { store } from "@redux";
import { AuthActions, AuthThunks } from "@modules";
import { getExpirationTokenInfoFromExp } from "@utils";

const EXPIRATION_TIME_KEY = "exp";

/* istanbul ignore next */
const updateAccessToken = async (accessToken: string) => {
  const decodeToken = jwtDecode(accessToken) as Record<string, number>;
  const expirationTokenInfo = getExpirationTokenInfoFromExp(
    decodeToken[EXPIRATION_TIME_KEY]
  );
  const authToken = store.getState().auth.authToken;
  await store.dispatch(
    AuthActions.setAuthToken({
      ...authToken,
      emissionDate: expirationTokenInfo.emissionDate,
      expirationDate: expirationTokenInfo.expirationDate,
      expiresIn: expirationTokenInfo.expireIn,
      accessToken,
    })
  );
};

/* istanbul ignore next */
const handleError = async (error: any): Promise<void> => {
  store.dispatch(AuthActions.setLogoutUser(true));
};

/* istanbul ignore next */
export const refreshLink = new TokenRefreshLink({
  accessTokenField: "accessToken",
  fetchAccessToken: async (): Promise<any> => {
    return store.dispatch(AuthThunks.refreshToken());
  },
  handleError,
  handleFetch: updateAccessToken,
  isTokenValidOrUndefined: (): boolean => {
    const expirationDate = store.getState().auth.authToken?.expirationDate;
    if (!expirationDate) {
      // unauthenticated queries must not attempt to refresh token
      return true;
    }
    return moment(expirationDate).isAfter(moment().add(60, 'seconds'));
  },
});